import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import CouponApi from "../../../api/coupon.api";

function CouponModal({ data, setModalOpen, listHandler }) {
  const [couponData, setCouponData] = useState(data);

  // ----- 취소
  const [cancelModalOpen, setCancelModalOpen] = useState(false);

  const cancelFunc = async () => {
    try {
      const data = {
        ids: [couponData.id],
      };
      await CouponApi.delete(data);
      toast(toastMsg.update);
      setCancelModalOpen(false);
      setCouponData({ ...couponData, couponStatus: "CANCEL" });
      listHandler();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <ModalWrapper>
        <ModalBox>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <TableTitle style={{ marginBottom: "0px" }}>
              {"쿠폰 발행 내역 상세"}
            </TableTitle>
            <img
              style={{
                cursor: "pointer",
              }}
              src="/assets/admin/icons/ico_popup_close.svg"
              alt=""
              onClick={() => setModalOpen(false)}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              overflowY: "auto",
            }}
          >
            <DetailPageForm>
              <DetailFormTitle>{"쿠폰명"}</DetailFormTitle>
              <DetailFormText>{couponData.title}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"유형"}</DetailFormTitle>
              <DetailFormText>
                {couponData.couponType === "PRICE" ? "금액 할인" : "%할인"}
              </DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"할인 금액"}</DetailFormTitle>
              <DetailFormText>{`${couponData.amount}${couponData.couponType === "RATIO" ? "%" : "원"}`}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>{"사용 기간"}</DetailFormTitle>
              <DetailFormText>{`${moment(couponData.startDate).format("YYYY/MM/DD")} ~ ${moment(couponData.endDate).format("YYYY/MM/DD")}`}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm style={{ alignItems: "flex-start" }}>
              <DetailFormTitle>{"발급 아이디"}</DetailFormTitle>
              <DetailFormText
                style={{ maxWidth: "520px", wordBreak: "break-all" }}
              >
                {(couponData.issuedMemberAccounts ?? []).join(", ") || "-"}
              </DetailFormText>
            </DetailPageForm>
          </div>
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            {couponData.couponStatus === "POSSIBLE" ? (
              <SaveBtn
                style={{
                  position: "relative",
                  background: "#fff",
                  color: "#636C73",
                }}
                text={"발급취소"}
                onClick={() => setCancelModalOpen(true)}
              />
            ) : undefined}
          </div>
        </ModalBox>
      </ModalWrapper>
      {cancelModalOpen ? (
        <Modal
          negative={true}
          title={"발급 취소 하시겠습니까?"}
          text={"취소된 쿠폰은 복구가 불가합니다."}
          setModalOpen={setCancelModalOpen}
          onClick={() => {
            cancelFunc();
          }}
        />
      ) : null}
    </>
  );
}

export default CouponModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 30;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 1064px;

  padding: 50px;
  border: 1px solid #d7dbe0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  /* 스크롤바 스타일 */
  &::-webkit-scrollbar {
    width: 17px; /* 스크롤바 너비 */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* 스크롤바 트랙 배경색 */
    border-radius: 10px; /* 스크롤바 트랙 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바 색상 */
    border: 7px solid #fff;
    border-radius: 10px; /* 스크롤바 둥근 모서리 */
  }
`;
